import React, { Component } from "react";
import "react-toggle/style.css";
import "rc-input-number/assets/index.css";
import styled from "styled-components";
import { connect } from "react-redux";
import { Row, Col } from "styled-bootstrap-grid";
import Toggle from "react-toggle";
import Footer from "../../../../Shared/Footer";
import {
  getCentralTimesheetData,
  saveTechnicianWorkHours,
} from "../../../../../Actions/TechnicianTimesheet";
import { format } from "date-fns";
import { withRouter } from "react-router-dom";
import {
  TimeConverstion,
  GetTimeDateDiff,
} from "../../../../../Api/Utils/ReuseableFunctions";
import { userDataTech } from "../../../../../Actions/UserTechData";
import { withTranslation, Trans } from "react-i18next";
import { logoutUser, resetsaveTimesheetMessage } from "../../../../../Actions";
class CentralHoursLogin extends Component {
  date = format(new Date(), "dd/MM/yyyy");
  constructor(props) {
    super(props);
    this.data = {};
    this.changedValues = false;
    this.state = {
      formData: {
        actualBreakHour: 0,
        actualEndTime: "00:00",
        actualStartTime: "00:00",
        addtnlHours: 0,
        callOuts: [],
        comments: "",
        expectedBreakHour: 0,
        expectedEndTime: "00:00",
        expectedStartTime: "00:00",
        isCallOutOrRoadside: "N",
        shiftId: "",
        ssoId: "",
        isBeforeSubmitted: "N",
        workingHours: 0,
      },
      timeDiffrence: 0,
      extraAdjustment: false,
      changedValues: false,
    };
    this.expectedTimeDiff = 0;
    this.handleFormChange = this.handleFormChange.bind(this);
    this.calculateExpectedHours = this.calculateExpectedHours.bind(this);
  }
  handleFormChange(val, name) {
    let formData = JSON.parse(JSON.stringify(this.state.formData));
    formData[name] = val;
    this.setState(
      {
        formData,
      },
      () => {
        this.calculateExpectedHours();
      }
    );
  }

  componentDidMount() {
    this.props.dispatch(
      getCentralTimesheetData({
        ssoId: this.props.ssoId,
        workshopLocation: this.props.branchId,
        timesheetDate: this.date,
      })
    );
  }

  calculateExpectedHours() {
    let formData = this.state.formData;
    let actualTimeDiff =
      GetTimeDateDiff(formData.actualStartTime, formData.actualEndTime) -
      Number(formData.actualBreakHour);
    formData.addtnlHours = actualTimeDiff - this.expectedTimeDiff || 0;
    formData.workingHours = actualTimeDiff || 0;

    this.setState({
      formData,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.techData !== this.props.techData) {
      if (this.props.techData) {
        let techData = JSON.parse(JSON.stringify(this.props.techData));
        let formData = techData;
        this.expectedTimeDiff =
          GetTimeDateDiff(
            techData.expectedStartTime,
            techData.expectedEndTime
          ) - Number(techData.expectedBreakHour);

        this.setState({ formData }, () => {
          this.calculateExpectedHours();
        });
      }
    }

    if (
      this.props.saveMessage !== void 0 &&
      this.props.saveMessage.type === "Timesheet Saved Successfully" &&
      this.props.saveMessage.message.errorCd === "SUCCESS"
    ) {
      let payload = {
        technicianId: this.props.ssoId,
        branchId: this.props.branchId,
        clckInOut: "OUT",
        reasonCd: "43",
        signedInBy: null,
        signedOutBy: this.props.ssoId,
        comments: null,
      };
      this.props.dispatch(logoutUser(payload));
      this.props.dispatch(resetsaveTimesheetMessage());
    }
  }

  nextStep = () => {
    let data = this.state.formData;
    data.paymentType = "T";
    this.props.dispatch(userDataTech(data));
    this.props.history.push("callouts");
  };

  submitData = () => {
    let data = this.state.formData;
    data.timesheetDate = format(new Date(), "dd/MM/yyyy");
    data.branchNumber = this.props.branchId;
    data.expectedBreakHour = Number(data.expectedBreakHour);
    data.isBeforeSubmitted = "Y";
    data.maintainenceUser = this.props.ssoId;
    data.paymentType = "T";
    this.props.dispatch(saveTechnicianWorkHours(data));
  };
  render() {
    const { t } = this.props;
    const {
      actualStartTime,
      actualEndTime,
      actualBreakHour,
      addtnlHours,
      comments,
      expectedBreakHour,
      isBeforeSubmitted,
      isCallOutOrRoadside,
      workingHours,
      breakDetails,
    } = this.state.formData;
    const { extraAdjustment, timeDiffrence } = this.state;
    var nextFlag = isCallOutOrRoadside === "Y";

    return this.props.techData !== undefined ? (
      <>
        <ParentDiv>
          <MainRow>
            <MainCol offset="1" md="11">
              <ROW>
                <WorkingHeading>
                  <Trans>standardWorkingHours</Trans>
                </WorkingHeading>
              </ROW>
              <TimeROW>
                <COL md="2">
                  <Textspan>
                    <Trans>startTime</Trans>
                  </Textspan>
                  <Span>
                    {this.props.techData.expectedStartTime || "00:00"}
                  </Span>
                </COL>
                <COL md="2">
                  <Textspan>
                    <Trans>endTime</Trans>
                  </Textspan>
                  <Span>{this.props.techData.expectedEndTime || "00:00"}</Span>
                </COL>
                <COL md="2">
                  <Textspan>
                    <Trans>unpaidBreak</Trans>
                  </Textspan>
                  <Span>{TimeConverstion(expectedBreakHour)}</Span>
                </COL>
              </TimeROW>
              <div className="centralBreaks">
                <Col md="6">
                  {(extraAdjustment || isBeforeSubmitted === "Y") && (
                    <AdjustedTimming>
                      <WorkingHeading>
                        {" "}
                        <Trans>actualTimings</Trans>
                      </WorkingHeading>
                      <TimeROW>
                        <COL md="4">
                          <div className="field-label">
                            <Trans>totalWorkingHours</Trans>
                          </div>

                          <label>{TimeConverstion(workingHours)}</label>
                        </COL>
                        <COL md="4">
                          <div className="field-label">
                            <Trans>startTime</Trans>
                          </div>
                          <label>{actualStartTime}</label>
                        </COL>
                        <COL md="4">
                          <div className="field-label">
                            <Trans>endTime</Trans>
                          </div>
                          <label>{actualEndTime}</label>
                        </COL>
                      </TimeROW>
                    </AdjustedTimming>
                  )}

                  <AdjustedTimming>
                    <COL md="7">
                      {(extraAdjustment ||
                        isBeforeSubmitted === "Y" ||
                        timeDiffrence !== 0) && (
                        <>
                          <div className="field-label">
                            <Trans>adjustmentToExpectedHours</Trans>
                          </div>
                          <div className="time-diff">
                            {TimeConverstion(addtnlHours)}
                          </div>{" "}
                        </>
                      )}
                    </COL>
                    <Col md="1"></Col>
                    <COL md="4">
                      <Textspan>
                        <Trans>callOutRoadsideHours</Trans>
                      </Textspan>
                      <ToggleButtonDiv>
                        <Togglebutton
                          defaultChecked={
                            this.props.techData.isCallOutOrRoadside === "Y"
                          }
                          icons={{ checked: "YES", unchecked: "NO" }}
                          name={"isCallOutOrRoadside"}
                          onChange={(event) => {
                            var val = event.target.checked ? "Y" : "N";
                            this.handleFormChange(val, event.target.name);
                          }}
                        />
                      </ToggleButtonDiv>
                    </COL>
                  </AdjustedTimming>
                  <CommentsDiv>
                    <Textspan>
                      <Trans>comments</Trans>
                    </Textspan>

                    <Comment
                      value={comments ? comments : ""}
                      //value={this.props.techData.comments}
                      placeholder={t("enterComments")}
                      name="comments"
                      onChange={(event) => {
                        this.handleFormChange(
                          event.target.value,
                          event.target.name
                        );
                      }}
                    />
                  </CommentsDiv>
                </Col>
                <Col offset="1" className="breakColumn" md="4">
                  <h6>
                    <Trans>totalBreakHours</Trans>{" "}
                  </h6>
                  <label>{TimeConverstion(actualBreakHour)} </label>
                  <div className="breakHeader">
                    <label>
                      <Trans>startTime</Trans>
                    </label>
                    <label>
                      <Trans>endTime</Trans>
                    </label>
                    <label>
                      <Trans>breaktime</Trans>
                    </label>
                  </div>

                  {breakDetails &&
                    breakDetails.map((breaksTaken, index) => (
                      <div key={index} className="breakContainer">
                        <label>{breaksTaken.startTime}</label>
                        <label>{breaksTaken.finishTime}</label>
                        <label>{breaksTaken.breakTime}</label>
                      </div>
                    ))}
                </Col>
              </div>
            </MainCol>
          </MainRow>
          <Footer height={"120px"}>
            {isBeforeSubmitted === "N" &&
              !extraAdjustment &&
              isCallOutOrRoadside === "N" && (
                <ul>
                  <li>
                    <label>
                      <Trans>haveyoucompletedabovespecifiedhours</Trans>
                    </label>
                  </li>
                  <li>
                    <>
                      <Button onClick={this.submitData}>
                        <Trans>yes</Trans>
                      </Button>
                      <Button
                        onClick={() => {
                          this.setState({ extraAdjustment: true });
                        }}
                        Color={true}
                      >
                        <Trans>no</Trans>
                      </Button>
                    </>
                  </li>
                </ul>
              )}
            {nextFlag ? (
              <ul>
                <li>
                  <label />
                </li>
                <li>
                  <Button className="font-size" onClick={this.nextStep}>
                    <Trans>next</Trans>
                  </Button>
                </li>
              </ul>
            ) : (
              <ul>
                <li>
                  <label />
                </li>
                <li>
                  <Button className="font-size" onClick={this.submitData}>
                    <Trans>submitAndLogout</Trans>
                  </Button>
                </li>
              </ul>
            )}
          </Footer>
        </ParentDiv>
      </>
    ) : (
      <div />
    );
  }
}

const mapStateToProps = ({
  auth,
  userMessage,
  technicianTimesheet,
  userTechData,
  saveTechnicianTimesheet,
  fetchTimesheetSecurity,
}) => {
  return {
    isAuthenticated: auth.isAuthenticated,
    ssoId: auth.ssoId,

    message: userMessage,
    userDefault: auth.user.defaultProfile,
    techData: technicianTimesheet.payload,
    saveData: userTechData.payload,
    branchId: auth.user ? auth.user.defaultProfile.branchId : null,
    saveMessage: saveTechnicianTimesheet,
    security: fetchTimesheetSecurity.securityList,
  };
};

export default withRouter(
  connect(mapStateToProps)(withTranslation()(CentralHoursLogin))
);

const ParentDiv = styled.div`
  .breakColumn {
    padding: 50px 0px 0px 40px !important;
    border-left: 1px solid #eeeeee;
    text-align: left;
    label {
      text-aling: left;
    }
  }
  .breakHeader {
    display: flex;
    label {
      font-size: 14px;
      width: 80px;
      font-weight: 500;
    }
  }
  .breakContainer {
    label {
      width: 80px;
      font-size: 14px;
      padding-bottom: 0px;
    }
    overflow-y: scroll;
    max-height: 200px;
    span {
    }
  }
  font-family: Trebuchet MS;
  li {
    list-style: none;
  }
  label {
    font-size: 18px;
  }
  .font-size {
    font-size: 13px;
  }
  .centralBreaks {
    display: flex;
    .dYEVAu {
      padding-right: 0px !important;
      padding-left: 0px !important;
    }
    .hXWOTP {
      padding-right: 0px !important;
      padding-left: 0px !important;
    }
  }
`;
const CommentsDiv = styled.div`
  padding-top :16px
  text-align:left
`;
const Comment = styled.input`
  width: 100%;
  border-top: none;
  border-right: none;
  border-left: none;
`;
const ToggleButtonDiv = styled.div`
  padding-top: 7px;
  .react-toggle--checked:hover:not(.react-toggle--disabled)
    .react-toggle-track {
    background-color: #00a6eb;
  }
  .react-toggle:hover:not(.react-toggle--checked) .react-toggle-track {
    background-color: #e0e0e0;
  }
  .react-toggle--checked .react-toggle-track {
    background-color: #00a6eb;
  }
  .react-toggle--checked .react-toggle-track-x {
    opacity: 0 !important;
  }
  .react-toggle--checked .react-toggle-thumb {
    left: 50px;
    border-color: #00a6eb;
  }
`;
const Togglebutton = styled(Toggle)`
  border-radius: 35px;
  font-size: 14px;
  .react-toggle-track {
    width: 81px;
    height: 34px;
    background-color: #e0e0e0;
  }
  .react-toggle-track-check {
    position: absolute;
    width: 14px;
    height: 10px;
    top: 8px;
    left: 14px;
    color: white;
  }
  .react-toggle-thumb {
    position: absolute;
    top: 4px;
    left: 5px;
    width: 26px;
    height: 26px;
    border: 1px solid #d9d9d9;
    border-radius: 50%;
    background-color: #fafafa;
    box-sizing: border-box;
    transition: all 0.15s ease;
  }
  .react-toggle-track-x {
    position: absolute;
    width: 10px;
    height: 10px;
    top: 8px;
    right: 25px;
    opacity: 1;
    transition: opacity 0.25s ease;
    color: white;
  }
  .react-toggle--checked .react-toggle-track-x {
    opacity: 0 !important;
  }
`;
const AdjustedTimming = styled(Row)`
  margin-left: 0px;
  margin-right: 0px;
  padding-top: 4%;
  position: relative;
  text-align: left;
  .time-diff {
    font-size: 24px;
    font-weight: bold;
  }
`;
const WorkingHeading = styled.div`
  font-size: 16px;
  color: #4a4a4a;
  font-weight: bold;
`;
const MainRow = styled(Row)`
  margin-left: 0px;
  margin-right: 0px;
`;
const MainCol = styled(Col)`
  padding-left: 0px;
  padding-right: 0px;
`;
const ROW = styled(Row)`
  margin-left: 0px;
  margin-right: 0px;
`;
const TimeROW = styled(Row)`
  margin-left: 0px;
  margin-right: 0px;
  text-align: left;
  padding-top: 10px;
  width: 100%;
`;
const COL = styled(Col)`
  padding-left:0px padding-right:0px text:align:left .field-label {
    display: block;
    font-size: 14px;
    line-height: 26px;
  }
`;
const Textspan = styled.span`
  font-size: 14px;
  color: #4a4a4a;
`;
const Span = styled.span`
  display: block;
`;
const Button = styled.button`
  background: ${(props) => (props.Color ? "#e1e5eb" : "#c4151c")};
  border-radius: 30px;
  padding: 0;
  border: ${(props) => (props.Color ? "1px solid #96989a;" : "none")};
  height: 40px;
  width: 150px;
  color: ${(props) => (props.Color ? "#939292;" : "#ffffff")};
  font-weight: 50;
  position: relative;
  left: 0px;
  font-size: 16px;
  margin-left: 10px;
  margin-right: 10px;
`;
